module.exports = __webpack_public_path__ + "static/img/starwars.5398455.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/starwars.jpg
// module id = 0NlF
// module chunks = 1